
















































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";

// Mixins
import AdminBrandId from "@/mixins/adminBrandId";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { FraudDetectionTypes } from "@/data/enums";

@Component({
  components: {
    "fraud-rules-table": () =>
      import("@/components/app/admin/settings/fraud/fraudRulesTable.vue")
  }
})
export default class BrandFraudSettings extends Mixins(AdminBrandId) {
  @Prop({ default: false })
  public dynamicSettingsLoading!: boolean;

  public isLoading = true;
  public fraudDetectionTypes = FraudDetectionTypes;

  public created() {
    this.isLoading = false;
  }

  public get canCreate() {
    return (
      this.$userCan("create_brand_fraud_check_settings") ||
      this.$userCan("create_organisation_fraud_check_settings")
    );
  }

  // Methods
  public addFraudDetectionRule(
    type: FraudDetectionTypes = FraudDetectionTypes.COUNTRY
  ) {
    this.$store.dispatch(
      `data/${DataModules.FRAUD_DETECTION}/openAddEditModal`,
      {
        props: {
          rule: {},
          type
        },
        events: {
          success: newRule => {
            if (newRule.type === FraudDetectionTypes.COUNTRY)
              // @ts-ignore
              this.$refs.countryTable.getData({ ignoreStored: true });
            else if (newRule.type === FraudDetectionTypes.IP)
              // @ts-ignore
              this.$refs.ipTable.getData({ ignoreStored: true });
          }
        }
      }
    );
  }

  @Watch("isLoading", { immediate: true })
  public onIsLoadingChange() {
    this.$emit("predefinedSettingsAreLoading", this.isLoading);
  }
}
